import { usePermission } from "@/hooks/use-permissions";
import { CAPABILITIES } from "@/config/permissions";

export const useHasWayaOfficialAccess = () => usePermission(CAPABILITIES.WAYA_OFFICIAL);


